import React, { useState } from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import ContactForm from "./ContactForm";
import { Mail, Phone, Send, MessageCircle } from "lucide-react";
import "./contact-us.scss";

// Simple modal — always visible when open === true
const Modal = ({ open, onClose, title, description, children }) => {
  if (!open) return null;

  return (
    <div className="teleport-modal-overlay" onClick={onClose}>
      <div
        className="contactus-dialog"
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
      >
        <button className="contactus-close" onClick={onClose}>
          ×
        </button>
        <h2 className="contactus-title" style={{ fontSize: "22px" }}>
          {title}
        </h2>
        <p className="contactus-subtitle" style={{ fontSize: "14px" }}>
          {description}
        </p>
        {children}
      </div>
    </div>
  );
};

export default function ContactUs() {
  const [modal, setModal] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    inquiryType: "",
    subject: "",
    message: "",
  });

  const handleChange = (f, v) => setFormData((p) => ({ ...p, [f]: v }));
  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you! We’ll get back to you soon.");
    setModal(null);
  };

  const copyEmail = async () => {
    await navigator.clipboard.writeText("support@teleportapp.sg");
    alert("Copied!");
  };

  return (
    <>
      <Navbar />
      <div className="contactus-page">
        <div className="contactus-inner">
          <div className="contactus-header">
            <h1 className="contactus-title">Contact Us</h1>
            <p className="contactus-subtitle">
              Have a question or need help? We're here to assist you.
            </p>
          </div>

          <div className="contactus-options">
            <button className="contactus-chip" onClick={() => setModal("form")}>
              <Send /> Contact Form
            </button>
            <button className="contactus-chip" onClick={() => window.open("https://tawk.to/chat/68a04664de044319242d0a08/1j2p15uu2")}>
              <MessageCircle /> Chat Support
            </button>
            <button className="contactus-chip" onClick={() => setModal("email")}>
              <Mail /> Email
            </button>
            <button className="contactus-chip" onClick={() => setModal("whatsapp")}>
              <Phone /> WhatsApp
            </button>
          </div>
        </div>
      </div>

      {/* === Contact Form Modal === */}
      <Modal
        open={modal === "form"}
        onClose={() => setModal(null)}
        title="Contact Form"
        description="Fill in the form and we’ll get back to you shortly."
      >
        <ContactForm
          formData={formData}
          onChange={handleChange}
          onSubmit={handleSubmit}
        />
      </Modal>

      {/* === Email Modal === */}
      <Modal
        open={modal === "email"}
        onClose={() => setModal(null)}
        title="Email Us"
        description="Shoot us an email and our Teleport Now Team will zoom right back to you!"
      >
        <div className="contactus-email-box">
          <div className="contactus-email-input">
            <Mail className="icon" />
            <span>support@teleportapp.sg</span>
            <button className="copy-btn" onClick={copyEmail}>
              Copy
            </button>
          </div>
          <a
            href="mailto:support@teleportapp.sg?subject=Teleport%20Now%20Support%20Request"
            className="contactus-email-button"
          >
            Open Email App
          </a>
        </div>
      </Modal>

      {/* === WhatsApp Modal === */}
      <Modal
        open={modal === "whatsapp"}
        onClose={() => setModal(null)}
        title="WhatsApp"
        description="We’re just a WhatsApp away — chat with us during operating hours!"
      >
        <div className="contactus-whatsapp-box">
          <div className="whatsapp-line">
            <Phone className="icon" /> <span>+65 9138 6774</span>
          </div>
          <a
            href="https://wa.me/6591386774?text=Hello%20Teleport%20Now%20Support"
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-whatsapp-button"
          >
            Open WhatsApp
          </a>
          <p className="contactus-hours">Mon–Fri, 9 AM – 7 PM (GMT+8)</p>
        </div>
      </Modal>

      <Footer />
    </>
  );
}
